/* eslint-disable react/require-default-props */
import React, { CSSProperties } from "react";

import "./ButtonLoader.scss";
import "./ButtonLoader-states.scss";
import "./ButtonLoader-animations.scss";
import { CircularProgress } from "@mui/material";

interface ButtonLoaderProps {
  type?: "button" | "submit" | "reset";
  style?: CSSProperties;
  className?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  secondary?: boolean;
}

const ButtonLoader = ({
  type,
  style,
  className,
  isDisabled,
  isLoading,
  onClick,
  children,
  secondary,
}: ButtonLoaderProps) => (
  <button
    type={type}
    className={`${
      secondary ? "buttonLoader__secondary" : "buttonLoader__button"
    } ${className} ${isDisabled ? "is--disabled" : ""}`}
    onClick={onClick}
    style={style}
    disabled={isDisabled || isLoading}
  >
    {isLoading ? (
      <CircularProgress
        style={{
          color: secondary ? "blue" : "white",
          marginLeft: 10,
          marginTop: 5,
          marginBottom: 5,
        }}
        size={20}
      ></CircularProgress>
    ) : (
      <p className={`buttonLoader__label`}>{children}</p>
    )}
  </button>
);

export default ButtonLoader;
